import React, { useState, useEffect } from 'react';
import { fetchLocutorName } from './FetchUpdateUserData';

export function ClientName({ managerId }) {
  const [name, setName] = useState('');

  useEffect(() => {
    let isMounted = true;
    if (managerId) {
      fetchLocutorName(managerId).then((data) => {
        if (isMounted) {
          const fname = data.fname;
          const lname = data.lname.slice(0, 1);
          setName(`${fname} ${lname}.`);
        }
      }).catch(error => {
        console.error("Помилка при отриманні імені менеджера:", error);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [managerId]);

  return <p style={{textWrap: "nowrap"}}>{name}</p>;
}
